import React, { useEffect, useState } from "react";
import "../../help/components/HelpPage.css";
import { Container, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { getRequestcall } from "../../comman/util/getRequest";
import { GET_PAGE } from "../../constants/apiurl";
import { useTranslation } from "react-i18next";

function UsefulPage(props) {
  let getPage = window.location.pathname.split("/").pop();
  const { pathname } = useLocation();
  const [aboutus, setAboutus] = useState();
  const {t} = useTranslation();
  // eslint-disable-next-line
  useEffect(() => {
    (async () => getPagecontent())();
    // eslint-disable-next-line
  }, [pathname]);

  // eslint-disable-next-line
  useEffect(() => {
    (async () => getPagecontent())();
    // eslint-disable-next-line
  }, [props.language]);

  const getPagecontent = async () => {
    let getResponse = await getRequestcall(
      GET_PAGE + `?slug=${getPage}&lang=${props.language.toLowerCase()}`,
      ""
    );
    if (getResponse?.status === 200) {
      let getContent = await getResponse.json();
      setAboutus(getContent?.data?.description);
      const strTitle = `pages.meta.${getContent?.data?.slug}.title`
      const description = `pages.meta.${getContent?.data?.slug}.description`
      props?.fetchHeaderContent(t(strTitle), t(description), "");
    }
  };

  return (
    <>
      <aside className="help_page">
        <Container className="help_container pb-4 mt-5">
          <div className="col-md-12">
            <Row className="help_row">
              <div className="col-12">
                <div
                  dangerouslySetInnerHTML={{
                    __html: aboutus,
                  }}
                ></div>
              </div>
            </Row>
          </div>
        </Container>
      </aside>
    </>
  );
}

const mapStateToProps = (state) => ({
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, { fetchHeaderContent })(UsefulPage);
